module.exports = __webpack_public_path__ + "img/zhifuBao.6ff59f17.png";